export const ReportFiltersConstant = {
    ALL: 1,
    YES: 2,
    NO: 3
}
